"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var yup = __importStar(require("yup"));
exports.ChangePasswordSchema = function (t) {
    yup
        .object()
        .shape({
        current_password: yup
            .string()
            .trim()
            .min(8)
            .max(64),
    })
        .concat(exports.PasswordValidationSchema(t, true));
};
exports.BaseUserFormSchema = function () {
    return yup
        .object()
        .shape({
        name: yup
            .string()
            .trim()
            .min(3)
            .max(24)
            .matches(/^[a-zA-Z0-9]+$/)
            .required(),
        phoneNumber: yup
            .string()
            .trim()
            .min(9)
            .max(9)
            .required()
            .matches(/^[1-9]{1}[0-9]{8}$/),
    })
        .concat(exports.EmailFormSchema());
};
exports.EmailFormSchema = function () {
    return yup.object().shape({
        email: yup
            .string()
            .trim()
            .email()
            .min(6)
            .max(320)
            .required(),
    });
};
exports.ExtendedUserFormSchema = function (t) {
    return yup.object().shape({
        role: yup
            .string()
            .required()
            .oneOf(['CLIENT', 'ADMIN']),
        status: yup
            .string()
            .required()
            .oneOf(['NEW', 'CONFIRMED']),
        price: yup
            .number()
            .required()
            .min(1)
            .max(999)
            .test('decimals', t('errors:decimals'), function (value) {
            var regex = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/;
            return regex.test(value);
        }),
    });
};
exports.PasswordValidationSchema = function (t, isRequired) {
    return yup.object().shape({
        password: yup
            .string()
            .trim()
            .min(8)
            .max(64)
            .test('required', t('yup:mixed:required'), function (value) {
            return isRequired ? !!value : true;
        }),
        confirm_password: yup
            .string()
            .test('password-match', t('errors:password_match'), function (value) {
            return this.parent.password === value;
        }),
    });
};
//# sourceMappingURL=user.js.map